import { createGlobalStyle } from 'styled-components';
import { colors } from '../constants/colors';

export const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'Orgon';
        font-weight: 400;
        font-style: normal;
        src: url('https://pblx.s3.amazonaws.com/pnl/assets-www/fonts/Orgon-RegWeb.woff');
    }

    @font-face {
        font-family: 'Orgon';
        font-weight: 700;
        font-style: normal;
        src: url('https://pblx.s3.amazonaws.com/pnl/assets-www/fonts/Orgon-BolWeb.woff');
    }

    * {
        box-sizing: border-box;
    }

    html,
    body {
        height: 100%;
        margin: 0;
    }

    body {
        font-family: 'Orgon', Arial, Helvetica, sans-serif;
        line-height: 1.3;
        color: ${colors.black};
    }

    a {
        color: ${colors.black};
    }
    
    p {
        margin: 0;
        line-height: 1.5;
    }

    h3 {
        margin: 30px 0 15px;
        line-height: 1.5;
    }

    h4 {
        margin: 10px 0;
    }
`;
